import React, { useEffect, useState } from "react";
import { API_URL } from "..";

const CityModal = ({ show, onClose, data, onSaved }) => {
  const [name, setName] = useState("");
  const isEdit = data && data.id;

  useEffect(() => {
    if (isEdit) setName(data.name);
    else setName("");
  }, [data, isEdit]);

  if (!show) return null;

  const handleSubmit = async () => {
    if (!name.trim()) {
      alert("City name is required");
      return;
    }

    const method = isEdit ? "PUT" : "POST";
    const url = isEdit
      ? `${API_URL}/api/city/${data.id}`
      : `${API_URL}/api/city`;

    const res = await fetch(url, {
      method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ name }),
    });

    if (res.ok) {
      onSaved();
      onClose();
    } else {
      alert("Failed to save city");
    }
  };

  return (
    <div className="modal show" style={{ display: "block", background: "#00000080" }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{isEdit ? "Edit City" : "Add New City"}</h5>
            <button className="btn-close" onClick={onClose}></button>
          </div>

          <div className="modal-body">
            <label className="form-label">City Name</label>
            <input
              type="text"
              className="form-control"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="e.g., Karachi, Lahore, Islamabad"
            />
          </div>

          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button className="btn btn-primary" onClick={handleSubmit}>
              {isEdit ? "Update" : "Save"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CityModal;
